import React from 'react';
import './AboutUs.scss';
import useDocumentTitle from '../Title/useDocumentTitle';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FaHandshakeSimple } from "react-icons/fa6";

const AboutUs = () => {
  useDocumentTitle("Balkanflix - O nama");

  const friends = [
    {
      name: "ZmajevaKugla.rs",
      link: "https://zmajevakugla.rs",
      logo: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/main/partnerzkrs.webp"
    },
    {
      name: "AnimeOverdose",
      link: "https://anime-overdose.com",
      logo: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/main/partneraods.webp"
    },
    {
      name: "Anime Balkan",
      link: "https://animebalkan.org/",
      logo: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/main/partnerab.webp"
    },
    {
      name: "GledajCrtace",
      link: "https://www.gledajcrtace.xyz/",
      logo: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/main/GC.png"
    }
  ];

  const teamMembers = [
    {
      name: "JatMi",
      role: "Vlasnik/ Developer/ Prevodilac",
      image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-JatMi.jpg",
      description: "Ćao, ja sam Mijat. Trudim se da saslušam sve želje i kritike gledalaca, i ono što je moguće ispunim."
    },
    {
      name: "Strax",
      role: "Vlasnik/ Developer/ Prevodilac",
      image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Strax.jpg",
      description: "Pozz, ja sam Strahinja, programer, prevodilac i jedan od 2 vlasnika sajta."
    },
    {
      name: "Dušan",
      role: "Upravnik/ Prevodilac",
      image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Dusan.jpg",
      description: "Pozdrav, ja sam Dušan, prevodilac sam na BalkanFlix-u. Od mene očekujte konstantno i kvalitetno prevođenje anime serijala!!!"
    },
    {
      name: "Breaker",
      role: "Koordinator/ Prevodilac",
      image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Breaker.jpg",
      description: "Zdravo svima,ja sam Matija, trudim se da sve uredno funkcioniše i da svi članovi tima budu zadovoljni. Takođe, prevodim anime serijale i nadam se da ćete uživati u njima."
    },
    {
      name: "Doksi",
      role: "Prevodilac/ Discord Admin",
      image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Doksi.jpg",
      description: "Zdravo, ja sam Marko, Administrator na BalkanFlix dicord serveru i prevodilac na sajtu, trudim se da redovno dovodim nove članove i mnogo promovišem sajt."
    },
    {
      name: "Milica",
      role: "Prevodilac",
      image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Milica.jpg",
      description: "Ćao, ja sam Milica. Ljubitelj sam animea i prevodilac na Balkanflix-u. Potrudiću se da vam pružim kvalitetan prevod vaših omiljenih serijala."
    },
    {
      name: "Ezio",
      role: "Prevodilac",
      image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Ezio.jpg",
      description: "Zdravo svima, ja sam Ezio. Planiram da radim sto profesionalnije prevode koji iskazuju originalne emocije animea."
    },
    {
        name: "Eldrin",
        role: "Prevodilac",
        image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Eldrin.jpg",
        description: "Pozdrav Svima Ja sam Eldrin, i ujedno prevodilac za dečije anime, pokušaću da što više oživim starije anime, pa znate šta možete očekivati od mene."
    },
    {
        name: "Wini",
        role: "Prevodilac",
        image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Wini.jpg",
        description: "Zovem se Vineto, i svojom posvećenošću prevođenju anime filmova unosim duh originala u svaki red dijaloga."
    },
    {
        name: "Nikola",
        role: "Marketing/ Moderator",
        image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Nikola.jpg",
        description: "Pozdrav, Ja sam Nikola, bavim se Marketingom, od mene očekujte kvalitetne Tiktok video snimke!!!"
    }, 
    {
        name: "Marko",
        role: "Moderator",
        image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Marko.jpg",
        description: "Ćao ja sam Marko, pomocnik sam na BalkanFlix serveru i pomažem sa izbacivanjem epizoda."
    },
    {
        name: "Veki",
        role: "Moderator",
        image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Veki.jpg",
        description: "Ćao svima ja sam Veki moderator sam na BalkanFlixu!"
    },
    {
      name: "Pavke",
      role: "Discord Admin",
      image: "https://raw.githubusercontent.com/Strale2006/SlikeStranice/refs/heads/main/Pfp-Pavke.jpg",
      description: "Ćao, ja sam Pavke. Administrator sam na server BalkanFlix. Uživam u radu i dajem sve od sebe."
    }
  ];

  return (
    <section className="about-us">
      <Helmet>
        <title>Balkanflix - O nama</title>
      </Helmet>
      <div className="about-us-content">
        <h1>Balkanflix Anime – Gledaj Anime Sa Prevodom Potpuno Besplatno</h1>
        <p>
          Balkanflix predstavlja revolucionarni online servis posvećen ljubiteljima animea širom Balkana.
          Naša misija je da spojimo strast prema anime kulturi sa jedinstvenim balkanskim duhom.
        </p>
        <hr/>
        <h1>Prijatelji sajta <FaHandshakeSimple /></h1>
        <div className="friends-section">
          {friends.map((friend, index) => (
            <div className="friend" key={index}>
              <Link to={friend.link} target="_blank" rel="noopener noreferrer">
                <img src={friend.logo} alt={`Logo ${friend.name}`} />
                <p className="friend-p">{friend.name}</p>
              </Link>
            </div>
          ))}
        </div>

        {/* STUFF TIM SEKCIJA */}
        <section className="stuff-team">
          <h2>Stuff Tim</h2>
          <div className="team-members">
            {teamMembers.map((member, index) => (
              <div className="team-member" key={index}>
                <div className="image-wrapper">
                  <img src={member.image} alt={member.name} />
                  <div className="overlay">
                    <p className="description">{member.description}</p>
                  </div>
                </div>
                <p className="member-name">{member.name}</p>
                <p className="member-role">{member.role}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
      <div className="anime-image">
        <img src="/Balkanflix-removebg.png" alt="Anime on Balkanflix" />
      </div>
    </section>
  );
};

export default AboutUs;